import { render, staticRenderFns } from "./BookingCreate.vue?vue&type=template&id=bd2d22a8&scoped=true&lang=pug"
import script from "./BookingCreate.vue?vue&type=script&lang=js"
export * from "./BookingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d22a8",
  null
  
)

export default component.exports